import Grid from '@mui/material/Grid';
import CVDCardGenetics from '../../../../../../components/Cards/CVDCardGenetics';
import CardElements from "../../../../../../components/TextComps/CardElements";
import Hypmono from "./Hypmono/Hypmono";
import Hypmono_Variants from "./Hypmono/Hypmono_Variants";
import Hypmono_Signal from "./Hypmono/Hypmono_Signal";
import Renin from "./Renin/Renin";
import Renin_Variants from "./Renin/Renin_Variants";
import Renin_Signal from "./Renin/Renin_Signal";
import Hyp from "./Hyp/Hyp";
import Hyp_Variants from "./Hyp/Hyp_Variants";
import Hyp_Signal from "./Hyp/Hyp_Signal";

export default function Hypertension() {

return (
<>
<CVDCardGenetics

cardheadline='HYPERTENSION'
content = {<>
                
                <Grid container> 
               
                 <CardElements element1={<Hypmono />} element2={<Hypmono_Variants />} element3={<Hypmono_Signal />} />
                 <CardElements element1={<Renin />} element2={<Renin_Variants />} element3={<Renin_Signal />} />
                 <CardElements element1={<Hyp />} element2={<Hyp_Variants  />} element3={<Hyp_Signal />} />
               
                </Grid>
  
    </>}   
    
/>    
</>
)};
